const loadButtonChat = () => {
    $(document).ready(() => {
        $('.button__chat').addClass('button__chat--is-active');

        // $('.button__chat').click(e => {
        //   e.preventDefault();
        //   console.log('Chat button clicked. Yeeha.');
        // });
    });
};

// Module startup
const init = () => {
    loadButtonChat();
};

export { init };
